module.exports = __webpack_public_path__ + "img/ic_publicity_detail4_1.8ed0aaaf.jpeg";